class OptionsStore {
    options;

    constructor(options = {}) {
        this.options = options;
    }

    // eslint-disable-next-line no-unused-vars,class-methods-use-this
    getData() {
        throw new Error('Please utilize a proper existing store or implement your own.');
    }

    // eslint-disable-next-line class-methods-use-this,no-unused-vars
    setData(data) {
        throw new Error('Please utilize a proper existing store or implement your own.');
    }

    // eslint-disable-next-line no-unused-vars,class-methods-use-this
    removeData() {
        throw new Error('Please utilize a proper existing store or implement your own.');
    }
}

export default OptionsStore;
